module.exports = __webpack_public_path__ + "static/media/Monotype.b98f57ac.ttf";